/**
 * Created by LIDA1FH on 05/11/2016.
 */
module.exports = function (bootstrap) {
    bootstrap.run(['$rootScope', function ($rootScope) {
        $rootScope.sidebar = {};
    }]);

    bootstrap.directive('pageHeadline', ["$state", "$location", "$urlRouter", "$urlMatcherFactory", "$compile", "$q", "$window", "navigation", "$rootScope", function ($state, $location, $urlRouter, $urlMatcherFactory, $compile, $q, $window, navigation, $rootScope) {
        return {
            replace: true,
            template: require('directives/hmhs/pageHeadline.html'),
            controller: ["$scope", "navigation", function ($scope, navigation) {
                $scope.navigation = navigation;
            }],
            link: function (scope, element) {
                var links = element.find('nav');
                var linkFromState = function (state) {
                    for (z in scope.sidebar.links) {
                        if (scope.sidebar.links[z].state === state) {
                            return scope.sidebar.links[z];
                        }
                    }
                };
                var setActive = function (link) {
                    if (link) {
                        link.active = true;
                        scope.sidebar.heading = link.heading;
                        scope.sidebar.breadcrumb = link.breadCrumb;
                        scope.sidebar.description = link.description;
                        scope.sidebar.selectedLink = link.label;
                        scope.sidebar.current = link;

                    }
                   // scope.breadcrumbCount = getBreadcrumbsCount(scope);
                    //console.log("$scope.breadcrumbCount", scope.breadcrumbCount);
                    return link;
                };
                var getBreadcrumbsCount = function (scope) {
                    if (scope.sidebar.breadCrumb.quaternary !== undefined) { return 4; }
                    else if (scope.sidebar.breadCrumb.tertiary !== undefined) { return 3; }
                    else if (scope.sidebar.breadCrumb.secondary !== undefined) { return 2; }
                    else if (scope.sidebar.breadCrumb.primary !== undefined) { return 1; }
                    else return 1;
                    
                };
               
                scope.handleHref = function (link) {
                    if (link.href) {
                        return link.deferredHref || $q.when(link.href).then(function (v) {
                            link.deferredHref = v;
                        });
                    }
                };
                scope.toggleLinks = function () {
                    if (!links.hasClass('ng-animate')) {
                        scope.linksopen = !scope.linksopen;
                    }
                };
                scope.toggleRefine = function (link, evt) {
                    evt.preventDefault();
                    link.showRefine = !link.showRefine;
                };

                scope.redirect = function (link, evt) {
                    if (link.onClick) {
                        link.onClick(evt);
                    }
                    scope.linksopen = false;
                };
                var link = linkFromState($state.current.name);
                if (link) {
                    setActive(link);
                }
                else {
                    // No link found.  Select 1st link.  This needs changed later to be an option rather than the default behaviour
                    setActive(scope.sidebar.links && scope.sidebar.links[0]);
                }

                var initLinks = function (event, toState, toParams, fromState, fromParams) {
                    for (z in scope.sidebar.links) {
                        scope.sidebar.links[z].active = false;
                    }
                    var foundLink = linkFromState($state.current.name) || scope.sidebar.links && scope.sidebar.links[0];
                    if (foundLink) {
                        setActive(foundLink);
                    }
                };
                scope.$watchCollection('sidebar.links', initLinks);
                scope.$on('$stateChangeSuccess', initLinks);

            }
        }
    }])
}